"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILocationStatusID = exports.IAgeRestrictionType = exports.IEntityType = exports.ISellerTypeID = exports.IModelTypeID = exports.IListingTypeID = exports.IEnvironment = void 0;
const index_1 = __importDefault(require("./communities/index"));
const constants_1 = require("./constants");
const index_2 = __importDefault(require("./homes/index"));
const index_3 = __importDefault(require("./token/index"));
const index_4 = __importDefault(require("./users/index"));
const types_1 = require("./types");
Object.defineProperty(exports, "IAgeRestrictionType", { enumerable: true, get: function () { return types_1.IAgeRestrictionType; } });
Object.defineProperty(exports, "IEntityType", { enumerable: true, get: function () { return types_1.IEntityType; } });
Object.defineProperty(exports, "IEnvironment", { enumerable: true, get: function () { return types_1.IEnvironment; } });
Object.defineProperty(exports, "IListingTypeID", { enumerable: true, get: function () { return types_1.IListingTypeID; } });
Object.defineProperty(exports, "ILocationStatusID", { enumerable: true, get: function () { return types_1.ILocationStatusID; } });
Object.defineProperty(exports, "IModelTypeID", { enumerable: true, get: function () { return types_1.IModelTypeID; } });
Object.defineProperty(exports, "ISellerTypeID", { enumerable: true, get: function () { return types_1.ISellerTypeID; } });
/**
 * Initializes a new instance of the MHBO API Client.
 *
 * @param {string} apiAccessKey The access key used to identify the account connecting to the API.
 * @param {string} apiSecret The secret key used to sign requests for this account.
 * @param {?IEnvironment} environment An optional override if a developer needs to test the client against a local development environment.
 * @returns {IMHBOApiClient} A wrapper for interacting with the MHBO API.
 */
function Client(credentials, environment) {
    return {
        communities: (0, index_1.default)(credentials, environment),
        homes: (0, index_2.default)(credentials, environment),
        token: (0, index_3.default)(credentials),
        users: (0, index_4.default)(credentials, environment),
    };
}
Client.MODEL_TYPES = constants_1.MODEL_TYPES;
Client.LISTING_TYPES = constants_1.LISTING_TYPES;
Client.HOME_TYPE = constants_1.HOME_TYPE;
exports.default = Client;
